import { useState } from 'react'

const useInfiniteScroll = (perPage = 20) => {
  const [page, setPage] = useState(1)
  const [allItems, setAllItems] = useState([])
  const [hasMore, setHasMore] = useState(true)

  const appendItems = (newItems) => {
    setAllItems((prev) => {
      const base = page === 1 ? [] : prev
      const existingIds = new Set(base.map((item) => item.id))
      const unique = newItems.filter((item) => !existingIds.has(item.id))
      return [...base, ...unique]
    })
    setHasMore(newItems.length === perPage)
  }

  const loadMore = () => {
    if (hasMore) setPage((prev) => prev + 1)
  }

  const reset = () => {
    setPage(1)
    setHasMore(true)
    setAllItems([])
  }

  return { page, allItems, hasMore, appendItems, loadMore, reset }
}

export default useInfiniteScroll
